export const moods = [
  'Tender',
  'Intimate',
  'Passionate',
  'Energetic',
  'Adrenaline-pumping',
  'Thrilling',
  'Suspenseful',
  'Intriguing',
  'Surprising',
  'Melancholic',
  'Reflective',
  'Sorrowful',
  'Light-hearted',
  'Playful',
  'Cheeky',
  'Tense',
  'Nervous',
  'Foreboding',
  'Uplifting',
  'Euphoric',
  'Empowering',
  'Frantic',
  'Urgent',
  'Heart-pounding',
  'Enchanting',
  'Mystical',
  'Dreamlike',
  'Sentimental',
  'Wistful',
]
